import React from 'react';
import { Dropdown, Icon, MenuItem } from 'ui-library';
import { createUniqueKey, getClassNames } from 'utils';
import './CellWithMoreActions.css';

// Define the structure for individual actions
export interface CellAction {
    text: string;
    onClick: () => void;
    hidden?: boolean;
}

// Define the component's Props interface
export interface CellWithMoreActionsProps {
    value?: string;
    actions?: CellAction[];
    disabled?: boolean;
}

const CellWithMoreActions: React.FC<CellWithMoreActionsProps> = ({
    value = '',
    actions = [],
    disabled = false,
}) => {
    const className = getClassNames('cell-with-more-actions__icon', {
        'table-cell_disabled': disabled,
    });

    const stopPropagation = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };

    return (
        <div
            role="button"
            onClick={stopPropagation}
            onKeyDown={stopPropagation}
            tabIndex={-1}
        >
            <Dropdown
                placement="bottomRight"
                title={(
                    <Icon
                        role="button"
                        tabIndex={0}
                        className={className}
                        type={value}
                    />
                )}
                overlayClassName="cell-with-more-actions__dropdown"
            >
                {actions
                    .filter((action) => !action?.hidden)
                    .map((action, index) => (
                        <MenuItem
                            key={createUniqueKey(index, action.text)}
                            onClick={action.onClick}
                        >
                            {action.text}
                        </MenuItem>
                    ))}
            </Dropdown>
        </div>
    );
};

export default CellWithMoreActions;
